import { PurchasedWithMultipleProductsBuilder, Recommender, conditionBuilder } from "@relewise/client";
import fillSmallProduct from "./fillSmallProduct";
import { getUser } from "./utils";
const RELEWISE_DATASET_ID = relewiseData.relewise_dataset_id;
const RELEWISE_API_KEY = relewiseData.relewise_api_key;
const RELEWISE_SERVER_URL = relewiseData.relewise_server_url;
let recommender = false;

if (RELEWISE_API_KEY && RELEWISE_DATASET_ID && RELEWISE_SERVER_URL) {
  recommender = new Recommender(RELEWISE_DATASET_ID, RELEWISE_API_KEY, {
    serverUrl: RELEWISE_SERVER_URL,
  });
}

if (!customElements.get('relewise-cart-recommendations') && recommender) {
  class RelewiseCartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    async init() {
      this.language = relewiseData.current_locale;
      this.displayedAt = "powerstep";
      this.resultAmount = 4;
      this.productId = this.getAttribute('data-product-id');
      this.variantId = this.getAttribute('data-variant-id');
      this.productTypes = this.getAttribute('data-product-types-in-cart') ? this.getAttribute('data-product-types-in-cart').split(',').filter(type => type.trim() !== '') : [];
      this.remainingForFreeShipping = document.querySelector('.cart-drawer_progress-bar')?.getAttribute('data-remaining-money');
      this.user = await getUser();

      this.currency = relewiseData.current_currency;
      this.productCardTemplate = this.querySelector('#cart-recommendations-product-template');
      this.productsInCart = this.getAttribute('data-products-in-cart') ? JSON.parse(this.getAttribute('data-products-in-cart').replace(/'/g, '"').replace(/(\w+):/g, '"$1":')) : [];
      this.baseOnFreeShipping = this.getAttribute('data-base-on-free-shipping');
      if (this.baseOnFreeShipping) {
        this.priceMinimum = this.remainingForFreeShipping > 1 ? parseInt(this.remainingForFreeShipping) : 0;
        this.priceMaximum = this.remainingForFreeShipping > 1 ? this.priceMinimum + 100 : 500;
      } else {
        this.priceMinimum = 0;
        this.priceMaximum = 99999;
      }
      // Fetch recommendations
      this.recommendations = await this.getRecommendations();
      if (!this.recommendations) {
        console.log('No recommendations found for', this.productsInCart);
        this.remove(); // Remove the element if no recommendations are found
        return;
      }
      this.renderProductCards();
    }

    async getRecommendations() {
      const settings = {
        language: 'da',
        currency: this.currency,
        displayedAtLocation: this.displayedAt,
        user: this.user
      };

      let purchasedWithMultipleProductsBuilder = new PurchasedWithMultipleProductsBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          pricing: true,
          allData: true,
          allVariants: true
        })
        .setSelectedVariantProperties({
          displayName: true,
          pricing: true,
          allData: true,
        })
        .addProducts(this.productsInCart)
        .setNumberOfRecommendations(this.resultAmount)
        .filters(f => f
          .addProductSalesPriceFilter(this.priceMinimum, this.priceMaximum)
        );

      this.productTypes.forEach((productType) => {
        purchasedWithMultipleProductsBuilder = purchasedWithMultipleProductsBuilder.filters(f => f
          .addProductDataFilter(
            'ProductType',
            (conditionBuilder) => conditionBuilder.addEqualsCondition(productType, true),
            true,
            true,
            true
          )
        );
      })

      const results = await recommender.recommendPurchasedWithMultipleProducts(purchasedWithMultipleProductsBuilder.build());

      return results;
    }

    async renderProductCards() {
      const recommendationProducts = this.recommendations.recommendations;

      recommendationProducts.map(async (product) => {
        const productCard = fillSmallProduct(product, this.productCardTemplate, this.currency);        
        if (!productCard) return;      
        const img = productCard.querySelector('img');
        if (img) img.src += img.src.includes('?') ? '&width=100' : '?width=100';
        this.appendChild(productCard);
      })

      this.activateAddToCartLoadAnimation();
    }

    activateAddToCartLoadAnimation() {
      const addToCartButtons = this.querySelectorAll('.product-cart-item .suggestions-addtocart');
      addToCartButtons.forEach((button) => {
        button.addEventListener('click', function () {
          button.classList.add('loading');
        });
      });
    }
  }

  customElements.define('relewise-cart-recommendations', RelewiseCartRecommendations);
}